import { Typography } from '@mui/material';
import { useAuth0Login } from '@hooks/useAuth0Login';

export const LoginRedirectCallback = () => {
  const { hasSignInFailed } = useAuth0Login();
  return (
    <Typography variant="h5" component="h5">
      {hasSignInFailed ? 'Something went wrong...' : 'Redirecting to app...'}
    </Typography>
  );
};
